import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerPrincipal = styled.div`
  padding: 0 0 0 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-image: url("/imageBackHealth.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow-x: none;
`;

export const ContainerTransparent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 100px 0;
  margin-bottom: 10px;
  padding: 20px 20px;
  width: 60%;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);

  @media (max-width: ${Variables.maxLaptops}) {
    width: 85%;
  }
`;

export const ContainerTexts = styled.div`
  width: 80%;
  text-align: center;

  @media (max-width: ${Variables.maxTablet}) {
    width: 100%;
  }
`;

export const ContainerFormAndImage = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media (max-width: 820px) {
    flex-direction: column-reverse;
  }
`;

export const ContainerForm = styled.div`
  width: 45%;

  @media (max-width: 820px) {
    width: 100%;
  }
`;

export const ContainerImage = styled.div`
  width: 45%;

  @media (max-width: 820px) {
    width: 100%;
  }
`;

export const Image = styled.img`
  width: 100%;
  resize: contain;
`;

export const TextPrincipal = styled.p`
  font-size: 35px;
  font-weight: 800;
  overflow-wrap: break-word;

  @media (max-width: 820px) {
    font-size: 20px;
  }
`;

export const ContainerFooter = styled.div`
  align-self: center;
  width: 70%;
  display: flex;
  flex-direction: column;

  @media (max-width: 820px) {
    flex-direction: column-reverse;
  }
`;

export const TextTermsPerson = styled.div`
  margin: 10px 0;
  padding: 10px;
  align-self: flex-end;
  font-weight: 600;
  text-align: right;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: ${Variables.maxLaptops}) {
    width: 100%;
  }
`;

export const TextForgetPassword = styled.a`
  margin-top: 20px;
  text-decoration: none;
  color: ${Variables.colorOrange};
  align-self: center;
  cursor: pointer;
`;
